import { Box } from '@chakra-ui/react';
import NouveauChampionnatForm from 'features/championnats/components/NouveauChampionnatForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetChampionnatById } from 'features/championnats/championnat.api';
import Loader from 'common/components/Loader';
import { NotFound } from './ErrorPage';
import { RoutePath } from 'router/routes.paths';
import BPCPageHeading from 'common/components/BPCPageHeading';
import NouveauChampionnatPersonnaliseForm from 'features/championnats/components/NouveauChampionnatPersonnaliseForm';
import { useConnectedUserContext } from 'features/user/useConnectedUserContext';

export default function EditionChampionnatPage() {
  const { id } = useParams<{ id: string }>();
  const { championnat, isLoading } = useGetChampionnatById(id!);
  const navigate = useNavigate();
  const { user } = useConnectedUserContext();

  if (isLoading) {
    return <Loader fullScreen />;
  }

  if (
    !championnat ||
    (championnat.type === 'personnalise' &&
      championnat.createdByPlayerId !== user?.id)
  ) {
    return <NotFound />;
  }

  const { name } = championnat;

  return (
    <Box>
      <BPCPageHeading
        title={name}
        breadcrumbItems={[
          { to: RoutePath.home, name: 'Home' },
          { to: RoutePath.championnats, name: 'Championnats' },
          { to: `${RoutePath.championnats}/${id}`, name },
        ]}
      />

      {championnat.type === 'personnalise' ? (
        <NouveauChampionnatPersonnaliseForm
          championnat={championnat}
          onCancel={() => navigate(-1)}
        />
      ) : (
        <NouveauChampionnatForm
          championnat={championnat}
          submitButtonLabel="Modifier le championnat"
          onCancel={() => navigate(-1)}
        />
      )}
    </Box>
  );
}
